const DjiboutiSvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_4152_111301)">
      <path
        d="M18.2605 21.7391C18.2605 21.7391 5.86914 5.85508 5.85742 5.85789C9.47664 2.23859 14.4767 0 19.9996 0C31.0452 0 39.9996 8.95437 39.9996 20L18.2605 21.7391Z"
        fill="#338AF3"
      />
      <path
        d="M18.2605 20C18.2605 20 5.86914 34.1449 5.85742 34.1421C9.47664 37.7614 14.4767 40 19.9996 40C31.0452 40 39.9996 31.0456 39.9996 20H18.2605Z"
        fill="#6DA544"
      />
      <path
        d="M5.85785 5.85742C-1.95262 13.6679 -1.95262 26.3312 5.85785 34.1418C9.08543 30.9142 12.1896 27.8101 20 19.9996L5.85785 5.85742Z"
        fill="#F0F0F0"
      />
      <path
        d="M8.09426 14.7832L9.38918 18.7688H13.5803L10.1898 21.2323L11.4846 25.218L8.09426 22.7547L4.70371 25.218L5.99887 21.2323L2.6084 18.7688H6.79918L8.09426 14.7832Z"
        fill="#D80027"
      />
    </g>
    <defs>
      <clipPath id="clip0_4152_111301">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default DjiboutiSvg;
